@if (appCopy && appCopy.searchWidgetFull) {
  <div class="round-trip-discount-alert"
       [class.round-trip-discount-alert--extended]="extended">
    <p class="round-trip-discount-alert__text">
      {{ appCopy.searchWidgetFull.roundTripDiscountAlert }}
    </p>
    <div class="round-trip-discount-alert__icon" (click)="toggleContent()">
      <app-svg-icon
        icon="info"
        [fill]="'night-sky'"
        [width]="9"
        [height]="9"
      ></app-svg-icon>
    </div>
    <div class="round-trip-discount-alert__more"
         [class.round-trip-discount-alert__more--extended]="extended">
      <p class="round-trip-discount-alert__more-text">
        {{ appCopy.searchWidgetFull.roundTripDiscountAlertInfo}}
      </p>
      <div class="round-trip-discount-alert__more-icon" (click)="toggleContent()">
        <app-svg-icon
          icon="close-icon"
          [width]="5.32"
          [height]="5"
        ></app-svg-icon>
      </div>
    </div>
  </div>
}
